export const UNREAD_NOTIFICATIONS_REQUEST_START: string = 'notifications/unreadCount/REQUEST_START';
export const UNREAD_NOTIFICATIONS_REQUEST_FAIL: string = 'notifications/unreadCount/REQUEST_FAIL';
export const UNREAD_NOTIFICATIONS_REQUEST_SUCCESS: string = 'notifications/unreadCount/REQUEST_SUCCESS';

export const GET_NOTIFICATIONS_REQUEST_START: string = 'notifications/getAll/REQUEST_START';
export const GET_NOTIFICATIONS_REQUEST_FAIL: string = 'notifications/getAll/REQUEST_FAIL';
export const GET_NOTIFICATIONS_REQUEST_SUCCESS:string = 'notifications/getAll/REQUEST_SUCCESS';

export const READ_NOTIFICATIONS_REQUEST_START: string = 'notifications/read/REQUEST_START';
export const READ_NOTIFICATIONS_REQUEST_FAIL: string = 'notifications/read/REQUEST_FAIL';
export const READ_NOTIFICATIONS_REQUEST_SUCCESS: string = 'notifications/read/REQUEST_SUCCESS';